import { render, staticRenderFns } from "./PDPProductFamiliesItem.vue?vue&type=template&id=fd756758&scoped=true"
import script from "./PDPProductFamiliesItem.vue?vue&type=script&lang=js"
export * from "./PDPProductFamiliesItem.vue?vue&type=script&lang=js"
import style0 from "./PDPProductFamiliesItem.vue?vue&type=style&index=0&id=fd756758&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd756758",
  null
  
)

export default component.exports